import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import { useState, useEffect } from 'react';
/**
 * @return {import('./types').CurrentLocationState}
 */

var useCurrentLocation = function useCurrentLocation() {
  var _useState = useState({
    loading: true,
    error: '',
    coordinates: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];
  /**
   * @param {Position} position
   */


  var onLocationFounded = function onLocationFounded(position) {
    setState({
      loading: false,
      error: '',
      coordinates: {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
    });
  };
  /**
   * @param {PositionError} positionError
   */


  var onLocationError = function onLocationError(positionError) {
    setState({
      loading: false,
      error: positionError.message,
      coordinates: null
    });
  };

  useEffect(function () {
    if (!navigator.geolocation) {
      setState({
        loading: false,
        error: 'Location service not available!',
        coordinates: null
      });
    } else {
      navigator.geolocation.getCurrentPosition(onLocationFounded, onLocationError, {
        enableHighAccuracy: true
      });
    }
  }, []);
  return state;
};

export default useCurrentLocation;